import React from "react";
import {Form, FormInstance} from 'antd';
import {ContainerForm} from "./styles";
import Input from "antd/lib/input";
import {IdcardOutlined} from '@ant-design/icons';
import {AppCheckbox} from "../../global/styles";
import {IsCnpjAlphaNumeric, IsValidCnpjAlphaNumeric, formatCpfOrCnpj} from "../../utils/StringUtils";

interface IdentificationProps {
    formRef: FormInstance,
    company: string
    secondaryColor: string
    typeService: string
}

const Identification: React.FC<IdentificationProps> = ({
    formRef,
    company,
    typeService,
    secondaryColor,
    ...rest
}: IdentificationProps) => {
    return (
        <ContainerForm>
            <Form
                form={formRef}
                layout="vertical">
                {typeService !== "Cancelamento" ? (
                    <div>Agende agora a {typeService} do rastreador {company}</div>
                ) : null}
                <Form.Item
                    label="Informe o CPF/CNPJ:"
                    name="cpfCnpj"
                    getValueFromEvent={(event) => formatCpfOrCnpj(event?.target?.value || '')}
                    rules={[
                        { required: true, message: 'Informe o cpf/cnpj' },
                        {
                            validator: (_, value) => {
                                if (!value) {
                                    return Promise.resolve();
                                }

                                if (IsCnpjAlphaNumeric(value) && !IsValidCnpjAlphaNumeric(value)) {
                                    return Promise.reject(new Error('CNPJ inválido'));
                                }

                                return Promise.resolve();
                            }
                        }
                    ]}
                >
                    <Input addonBefore={<IdcardOutlined />} maxLength={18} />
                </Form.Item>
                <Form.Item rules={[{
                    validator: (_, value) =>
                        value ? Promise.resolve() : Promise.reject(new Error('Deve confirmar a titularidade'))
                }]} valuePropName="checked" name="confirmHolder">
                    <AppCheckbox color={"#DC3644"}>Declaro ser o titular deste CPF/CNPJ</AppCheckbox>
                </Form.Item>
            </Form>
        </ContainerForm>
    )
}

export default Identification;
